import { render, staticRenderFns } from "./ModKeywordsList.vue?vue&type=template&id=54f60f3e&scoped=true&"
import script from "./ModKeywordsList.vue?vue&type=script&lang=js&"
export * from "./ModKeywordsList.vue?vue&type=script&lang=js&"
import style0 from "./ModKeywordsList.vue?vue&type=style&index=0&id=54f60f3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f60f3e",
  null
  
)

export default component.exports